'use strict';

/**
 * @ngdoc component
 * @restrict 'E'
 * @description
 * The `mx-attachments-picker` is used to create a picker where user can select files, attached to an objects.
 * Uses `mx-multi-picker` as a base.
 *
 * @param {guid} relatedObjectId@ - Specifies related object id.
 * @param {string} relatedEntity@ - Specifies related entity name.
 *
 * @usage <mx-attachments-picker data-label="Attachments Picker" related-object-id="vm.objectId" related-entity="EntityName"></mx-attachments-picker>
 */
export function MxAttachmentsPickerDirective() {
	const directive = new mx.components.FormControlBase(MxAttachmentsPickerController, null);

	directive.template = `<mx-multi-picker
			data-name="{{vm.name}}"
			data-label="{{vm.label}}"
			ng-model="vm.model"
			data-item-title-field="DisplayString"
			data-item-id-field="Id"
			data-disabled="vm.disabled"
			read-only="vm.readOnly"
			data-load-items="vm.loadItems"
			data-load-on-typing="false"
			browse-lookup="vm.browseLookup"
			dropdown-html-class="{{::vm.dropdownHtmlClass}}"
			ng-required="(vm.required || vm.ngRequired) && !vm.disabled && !vm.readOnly"
			custom-validation="vm.customValidation"
			data-hint="{{vm.hint}}"
		></mx-multi-picker>`;

	angular.extend(directive.bindToController, {
		relatedObjectId: '@',
		relatedEntity: '@',
		ngRequired: '=?',
	});

	angular.extend(directive.require, {
		parentViewController: '?^^mxView',
	});

	delete directive.link;

	return directive;
}

MxAttachmentsPickerController.$inject = ['mx.SolutionBuilderAgent.DialogOpenerService', 'mx.sb.Attachment.MxAttachmentService'];

function MxAttachmentsPickerController(dialogOpener, attachmentService) {
	const vm = this;
	let refToPickerCtrl;
	vm.$onInit = function () {
		vm.loadItems = loadItems;
		vm.browseLookup = browseLookup;
	};

	function browseLookup() {
		const promise = dialogOpener.selectFiles(vm.relatedObjectId, vm.relatedEntity, undefined, vm.parentViewController && vm.parentViewController.mxView);

		return promise.then(function (data) {
			refToPickerCtrl.items = mapFileItem(data.files);
			return data.selectedObjects;
		});
	}

	function mapFileItem(items) {
		return items
			.map(function (item) {
				return {
					Id: item.id,
					DisplayString: item.name,
				};
			})
			.sort(function (a, b) {
				if (a.DisplayString > b.DisplayString) {
					return 1;
				}

				if (a.DisplayString < b.DisplayString) {
					return -1;
				}

				return 0;
			});
	}

	async function loadItems(searchText, pickerCtrl) {
		refToPickerCtrl = pickerCtrl;
		const result = await attachmentService.getFiles({
			objectIds: vm.relatedObjectId && [vm.relatedObjectId],
		});
		return mapFileItem(result);
	}
}
